var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-radio-group',{attrs:{"disabled":_vm.disabled},on:{"change":_vm.onChange},model:{value:(_vm.currentValue),callback:function ($$v) {_vm.currentValue=$$v},expression:"currentValue"}},_vm._l((_vm.options),function(item){return _c('a-radio',{key:item.id,attrs:{"value":item.value}},[_vm._v(_vm._s(item.name))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }